module.exports = __webpack_public_path__ + "static/media/simcase_wide.64330542.png";